import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const getEstimateInformation = async () => {
    // @ts-ignore
    const url = routable.getRoute('getEstimateInfo');

    // if (!url) {
    //     throw new Error('Route getEstimateInfo is not registered yet');
    // }

    try {
        const response = await $api.get(url);

        return response.data;
    } catch (error) {
        handleAxiosFetchErrorsSwal(error?.response?.data);
        return error;
    }
};
